export default __webpack_public_path__ + "static/media/b58.45e854cd.png";